// Animated Reviews Component
if (!customElements.get('reviews-animated')) {
  class ReviewsAnimated {
    constructor() {
      this.columns = document.querySelectorAll('[data-scroll-up], [data-scroll-down]');
      this.mobileColumn = document.querySelector('[data-scroll-up]');
      this.dots = document.querySelectorAll('.reviews-animated__dot');
      this.init();
      this.initMobileDots();
    }

    init() {
      if (!this.columns.length) return;

      // Pause animation when user hovers over a column
      this.columns.forEach(column => {
        column.addEventListener('mouseenter', () => {
          column.style.animationPlayState = 'paused';
        });

        column.addEventListener('mouseleave', () => {
          column.style.animationPlayState = 'running';
        });
      });

      // Pause animation when page is not visible
      document.addEventListener('visibilitychange', () => {
        this.columns.forEach(column => {
          column.style.animationPlayState = document.hidden ? 'paused' : 'running';
        });
      });
    }

    initMobileDots() {
      if (!this.mobileColumn || !this.dots.length) return;

      const cards = this.mobileColumn.querySelectorAll('.review-card-animated');

      // Update active dot on scroll
      this.mobileColumn.addEventListener('scroll', () => {
        const scrollLeft = this.mobileColumn.scrollLeft;
        const cardWidth = cards[0]?.offsetWidth || 0;
        const gap = 16; // 1rem
        const activeIndex = Math.round(scrollLeft / (cardWidth + gap));

        this.dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === activeIndex);
        });
      });

      // Click dot to scroll to card
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const card = cards[index];
          if (card) {
            card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        });
      });

      // Set first dot as active
      if (this.dots[0]) {
        this.dots[0].classList.add('active');
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ReviewsAnimated());
  } else {
    new ReviewsAnimated();
  }
}
